import { useI18n } from '../i18n/i18n';
import { useMemo, Fragment } from 'react';

import './Food.scss';
import Slider from 'react-slick';
import m from '../img/svg/bouquet-svgrepo-com.svg';
import { Icon } from './RSVP';
import v from '../img/svg/bowtie-svgrepo-com.svg';

export function Food() {
    const { food } = useI18n();
    const items = useMemo(() => {
        const result = [];
        food.bride.forEach((item, index) => {
            result.push([food.bride[index], food.groom[index]]);
        });
        return result;
    }, [food]);
    return <div className="food card">
        <FoodGrid items={items} titles={food.titles} />
    </div>;
}

function FoodGrid({ items, titles }) {
    const orDelimiter = useMemo(() => {
        return items.some(item => item[0].includes(' VAGY ') || item[1].includes(' VAGY ')) ? ' VAGY ' : ' OR ';
    }, [items]);

    const renderItem = (item) => {
        return item.split(orDelimiter).map((subItem, subKey) => {
            return <div key={subKey} style={{ padding: '8px' }}>
                {subKey > 0 && <span className="or">{orDelimiter}</span>}
                {subItem.split(', ').map((row, i) => <div key={i}>{row}</div>)}
            </div>;
        })
    };

    return <>
        {items.map((item, key) => {
            return <Fragment key={key}>
                <h4>{titles[key]}</h4>
                <div className="food-row">
                    <div className="food-cell desktop">
                        <Icon src={m} alt="Menyasszony" classNames={['gold6']} />
                        {renderItem(item[0])}
                    </div>
                    <div className="food-cell desktop">
                        <Icon src={v} alt="Vőlegény" classNames={['gold6']} />
                        {renderItem(item[1])}
                    </div>
                    <div className="mobile">
                        <Slider dots arrows>
                            <div>
                                <Icon src={m} alt="Menyasszony" classNames={['gold6']} />
                                {renderItem(item[0])}
                            </div>
                            <div>
                                <Icon src={v} alt="Vőlegény" classNames={['gold6']} />
                                {renderItem(item[1])}
                            </div>
                        </Slider>
                    </div>
                </div>
            </Fragment>;
        })}
    </>
}
